const header = {
    height: 48,
};

export { header };
